import LegalDocLayout from "@/pages/_legal/LegalDocLayout";

export default function TermsPage() {
  return (
    <LegalDocLayout
      titleKey="legal.termsTitle"
      introKey="legal.termsIntro"
      prefix="t"
      countKey="legal.termsSectionsCount"
      lastUpdated="2026-09-01"
    />
  );
}
